import type { AnswerValue, Answers, Template } from "./types";

export type MissingItem = { sectionId: string; questionId: string; title: string };

export function isAnswered(v: AnswerValue | null | undefined): boolean {
  if (v === undefined || v === null) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (Array.isArray(v)) return v.length > 0;
  return true;
}

/** Required questions in client sections without an answer. Info sections and deprecated questions never count. */
export function missingRequired(template: Template, answers: Answers): MissingItem[] {
  const out: MissingItem[] = [];
  for (const section of template.sections) {
    if (section.audience === "info") continue;
    for (const q of section.questions) {
      if (!q.required || q.deprecated || q.type === "info") continue;
      if (!isAnswered(answers[q.id])) out.push({ sectionId: section.id, questionId: q.id, title: q.title });
    }
  }
  return out;
}

/** Message for a number outside min/max, or null when valid. */
export function numberError(value: number, min?: number, max?: number): "range" | "min" | "max" | null {
  const low = min !== undefined && value < min;
  const high = max !== undefined && value > max;
  if (!low && !high) return null;
  if (min !== undefined && max !== undefined) return "range";
  return low ? "min" : "max";
}
